import script from "./PostForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PostForm.vue?vue&type=script&setup=true&lang=js"

import "./PostForm.vue?vue&type=style&index=0&id=3b5c3286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5c3286"]])

export default __exports__